/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  /**
   * Блок "Похожие запросы"
   */
  app.SimilarQueriesView = app.View.extend({
    template: '#similar-queries-template',
    el: '#js-similar-queries',

    /**
     * @inheritDoc
     */
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate(this.template);
      this.listenTo(this.model, 'sync', this.render);
    },

  });
})(jQuery);

}.call(window));